import React, { JSX } from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import CoreAIGeneratorForm from 'components/coreAIGeneratorForm';

interface PropsInterface {
	children?: React.ReactNode;
}

function PromptSection(props: PropsInterface): JSX.Element {
	return (
		<Box>
			<Box display={'flex'} gap={5} mb={16} flexDirection={'column'} alignItems={'center'}>
				<Heading
					as={'h2'}
					fontSize={{ base: '3xl', sm: '4xl', lg: '5xl' }}
					fontWeight={700}
					lineHeight={1}
					textAlign="center"
				>
					What do you want to create?
				</Heading>
				<Text fontSize={{ base: 'sm', sm: 'md' }} color={'fg.muted'}>
					Type your prompt - turn ideas into AI visuals instantly.
				</Text>
			</Box>
			<Box
				height={'auto'}
				width={'100%'}
				position={'relative'}
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
			>
				<Box
					position={'absolute'}
					top={10}
					height={{ base: '60px', lg: '60px' }}
					width={'99%'}
					boxShadow={{
						base: '0px 40px 30px rgba(0, 0, 0, 0.2)',
						lg: '0px 40px 30px rgba(0, 0, 0, 0.3)',
					}}
					bg={'transparent !important'}
				></Box>
				<Box w={'100%'} pt={120} mt={-120} overflowX={'hidden'} overflowY={'visible !important'}>
					<CoreAIGeneratorForm projectId={0} withoutShadow />
				</Box>
			</Box>
		</Box>
	);
}

export default PromptSection;
